import React, { useState } from "react";

import img5 from '../assets/img/02-2025/5_0.png';
import img6 from '../assets/img/02-2025/6_0.png';
import img7 from '../assets/img/02-2025/7_0.png';
import img8 from '../assets/img/02-2025/8_0.png';

import sornUp from '../assets/img/icon/sorn-up.svg';

export default function Select4(border) {

    const [dataS, setDataS] = useState(null);


    return (
        <>
            <div className="mb-4">
                <div className="row justify-content-center text-start">
                    <div className="col-6 col-md-3 col-lg-3">
                        <button className="btn text-center" onClick={e => setDataS(1)}>
                            <img src={img5} className="w-75 px-4" />
                            <h4 className="weight-700 mt-3 h4-respon" style={{}}>Objectives</h4>
                        </button>
                    </div>
                    <div className="col-6 col-md-3 col-lg-3">
                        <button className="btn text-center" onClick={e => setDataS(2)}>
                            <img src={img6} className="w-75 px-4" />
                            <h4 className="weight-700 mt-3 h4-respon" style={{}}>Participants</h4>
                        </button>
                    </div>
                    <div className="col-6 col-md-3 col-lg-3">
                        <a href="https://drive.google.com/file/d/1RFQIs09hxvdgDfpXd8uP8B68N5weZ6iP/view?usp=drive_link" target={"_blank"} className="btn text-center">
                            <img src={img7} className="w-75 px-4" />
                            <h4 className="weight-700 mt-3 h4-respon" style={{}}>Programme</h4>
                        </a>
                    </div>
                    <div className="col-6 col-md-3 col-lg-3">
                        <a href="https://drive.google.com/file/d/1eLVn_8dz8fAQjKfYKSi2OzsRXb5F0JdR/view?usp=drive_link" target={"_blank"} className="btn text-center">
                            <img src={img8} className="w-75 px-4" />
                            <h4 className="weight-700 mt-3 h4-respon" style={{}}>Document</h4>
                        </a>
                    </div>
                </div>
            </div>
            <div>
                <div className="d-none d-md-block">
                    <div className="row text-start" style={{ marginBottom: "-20px" }}>
                        <div className="col-12 col-md-3 col-lg-3 text-center">
                            {dataS === 1 && <img src={sornUp} className="" style={{ width: "50px", filter: "brightness(0) saturate(100%) invert(91%) sepia(55%) saturate(6319%) hue-rotate(315deg) brightness(109%) contrast(103%)" }} />}
                        </div>
                        <div className="col-12 col-md-3 col-lg-3 text-center">
                            {dataS === 2 && <img src={sornUp} className="" style={{ width: "50px", filter: "brightness(0) saturate(100%) invert(91%) sepia(55%) saturate(6319%) hue-rotate(315deg) brightness(109%) contrast(103%)" }} />}
                        </div>
                    </div>
                </div>
                {dataS === 1 ?
                    <div className="p-4" style={{ background: "#FFDE59", borderRadius: "15px" }}>
                        <ol>
                            <li>Enhance understanding of the Sufficiency Economy Philosophy (SEP) as a means to transform education and accelerate attainment of the SDGs (especially SDG 4)</li>
                            <li>Identify common education challenges and priorities for regional intervention and support</li>
                            <li>Recommend connectivity of policy issues and practical SDGs steps in both transforming education and promoting SDGs</li>
                            <li>Encourage networking opportunities among regional senior education officials fostering connection and collaborations</li>
                        </ol>
                    </div>
                    : dataS === 2 ?

                        <div className="p-4" style={{ background: "#FFDE59", borderRadius: "15px" }}>
                            <ol>
                                <li>Senior education officials at Ministries/Departments of Education that have at least 5 year’s experience in implementing and coordinating SDG programmes</li>
                                <li>Participants should be at director or assistant director level and be knowledgeable about their country’s overall strategy for integrating the SDGs in national curriculums, teacher training, policy making and other related areas.</li>
                                <li>Since the activity will be conducted in English, the nominated participant’s proficiency in English is important.</li>
                                <li>One participant will be nominated by the Ministry of Education of each Southeast Asian countries plus each from Japan, People’s Republic of China, and South Korea.</li>
                            </ol>
                        </div>

                        : null}
            </div>

        </>
    );
}